import FormGeneralError from 'components/formComponents/FormGeneralError';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUpdateUsersList } from 'reducers/misc';
import { UsersApi } from '../../api/usersApi';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addPluralTxt: boolean | undefined;
  ids: number[];
};

export const DeleteUsers: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  addPluralTxt,
  ids,
}) => {
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const dispatch = useDispatch();
  const setUpdateList = (status: boolean) =>
    dispatch(setUpdateUsersList(status));

  const deleteUser = async () => {
    setError('');
    setIsSubmitting(true);
    const result = await UsersApi.deleteUser(ids);
    if (result.data) {
      const paramItems = JSON.stringify(localStorage.getItem("updateItemTableParams") || '{}');
      togglePanelOpen(false);
      setUpdateList(true);
    }

    if (result.error) {
      const error = result.error.message;
      setError(error);
    }
    setIsSubmitting(false);
  };
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Delete user' + (addPluralTxt ? 's' : '')}
      position="right"
      primaryBtnTxt="Delete"
      secondaryBtnTxt="Cancel"
      givenClass="DeleteManagedUser"
      primaryBtnColor="BtnRed"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={deleteUser}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
      isSubmitting={isSubmitting}
    >
      {error && <FormGeneralError message={error} />}
      <p>
        Are you sure you want to delete{' '}
        {addPluralTxt ? 'these users' : 'this user'}?
      </p>
    </PopupOrPanel>
  );
};
